import React from 'react'
import { ChargingCardModel } from '../../../api/models/charging-card-model'
import { ChargingCardStatusChip } from 'src/Libs/e-mobility/shared/components/ChargingCardStatusChip'
import { Box, Stack, Typography } from '@mui/material'

interface ChargingCardLinkCellProps {
  card: ChargingCardModel
  shouldDisableCurrentRow: boolean
}

/**
 * Component for displaying charging card inside charging card to link wallboxes table cell
 * This component properly format all values for table cell
 */
export const ChargingCardLinkCell: React.FC<ChargingCardLinkCellProps> = ({ card, shouldDisableCurrentRow }) => {
  return (
    <Stack direction="row" p={1}>
      <Stack direction="column" minWidth={100} alignSelf="center" flex={1}>
        <Typography variant="body2" sx={theme => ({ color: shouldDisableCurrentRow ? theme.palette.grey.grey03 : theme.palette.grey.grey04 })}>
          {card.tokenId}
        </Typography>
        <Typography variant="subtitle1" sx={theme => ({ color: shouldDisableCurrentRow ? theme.palette.grey.grey03 : 'initial' })}>
          {card.cardName}
        </Typography>
        {card.user && (
          <Typography variant="body2" sx={theme => ({ color: shouldDisableCurrentRow ? theme.palette.grey.grey03 : 'initial', fontStyle: 'italic' })}>
            {card.user}
          </Typography>
        )}
      </Stack>
      <Box alignSelf="center" ml={2}>
        <ChargingCardStatusChip status={card.status} />
      </Box>
    </Stack>
  )
}
